"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var checkDispatchValue = function checkDispatchValue(middlewareData) {
  var dispatchValue = middlewareData.dispatchValue,
      modules = middlewareData.storeModules,
      features = middlewareData.features;
  var checkMiddleware = features === null || features === void 0 ? void 0 : features.check;

  if (dispatchValue !== null) {
    var modulePassRateArray = modules.filter(function (module) {
      var _module$middleware;

      var moduleCheckMiddleware = module === null || module === void 0 ? void 0 : (_module$middleware = module.middleware) === null || _module$middleware === void 0 ? void 0 : _module$middleware.check;

      if (typeof moduleCheckMiddleware === 'function') {
        return moduleCheckMiddleware;
      }
    }).map(function (module) {
      var _module$middleware2;

      var moduleCheckMiddleware = module === null || module === void 0 ? void 0 : (_module$middleware2 = module.middleware) === null || _module$middleware2 === void 0 ? void 0 : _module$middleware2.check;

      if (typeof moduleCheckMiddleware === 'function') {
        return moduleCheckMiddleware(middlewareData);
      }
    });
    var doModuleMiddlewarePass = modulePassRateArray.includes(!false) || modulePassRateArray.length === 0 ? true : false;

    if (!doModuleMiddlewarePass) {
      return false;
    }

    if (typeof checkMiddleware === 'function') {
      var doesFeatureCheckPass = checkMiddleware(middlewareData);

      if (doesFeatureCheckPass === true) {
        return true;
      }

      return false;
    }

    return true;
  }

  return true;
};

var _default = checkDispatchValue;
exports["default"] = _default;
module.exports = exports.default;